<template>
  <div :class="['emd-language-select', `_color_${color}`]">
    <select
        data-cy="toggle-language"
        @change="$emit('input', $event.target.value)"
        :value="value"
        data-testid="language-select"
    >
      <option
        v-for="lang in langs"
        :key="lang.code"
        :value="lang.code">{{ lang.flag }} {{ lang.name }}</option>
    </select>
    <div class="emd-language-select__arrow"/>
  </div>
</template>
<script>

export default {
  name: 'EmdLanguageSelect',
  props: {
    color: {
      type: String,
      required: false,
      default: 'subtle'
    },
    value: {
      type: String
    },
    dataCy: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      langs: [
        {
          code: 'en-US',
          name: 'English',
          flag: '🇺🇸'
        },
        {
          code: 'pt-BR',
          name: 'Português',
          flag: '🇧🇷'
        }
      ]
    }
  }
}
</script>
